var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcsmTulip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "181px",
    viewBox: "0 0 140 181",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(-146.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(146.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7164696,0 C53.5014166,5.33349005 59.8593584,10.618789 65.7902949,15.8558969 C58.9646095,22.0988815 52.740862,28.277191 47.1131625,34.3891302 C43.6730534,32.3911482 40.1063237,30.4127286 36.4149164,28.453784 C39.3253721,19.3575365 42.7588036,9.87256552 46.7164696,0 Z",
    id: "Path",
    fill: "#119682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2835305,0 C97.2414016,9.87307707 100.674984,19.3585195 103.584277,28.4563272 C90.9263167,35.1716274 79.7356318,42.1171288 69.9985638,49.2802507 C64.484479,45.221674 58.5008701,41.2329595 52.0484179,37.3161663 C63.3657054,25.1508167 77.111709,12.7122951 93.2835305,0 Z",
    id: "Path",
    fill: "#40CAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98842425,18.8131637 C27.9951114,29.50885 48.7782411,40.8423907 65.3378139,52.8137854 C50.2264664,64.6149905 38.9800306,76.9912343 31.5450257,89.8926163 C20.1487242,109.667753 17.0671479,126.951144 18.8968296,141.099619 C19.2825379,144.082207 19.8856655,146.932659 20.6800745,149.64616 L20.1840546,148.901109 C18.9619224,147.040633 17.7591314,145.08737 16.5782829,143.038336 C0.833645118,115.717871 -3.69630872,74.309481 2.98842425,18.8131637 Z",
    id: "Path",
    fill: "#088673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.011576,18.8131637 L135.47744,19.4724216 L135.47744,19.4724216 L132.441181,20.7957726 C83.7000393,42.2420553 51.6933155,66.2156201 36.4210097,92.7164668 C12.8040499,133.697162 26.691097,163.13866 47.0509216,174.914938 C67.4107479,186.691214 99.8047477,184.019026 123.421714,143.038335 C138.221677,117.357099 143.112341,79.2277712 138.093709,28.6503511 L137.759913,25.4050996 C137.528411,23.2303283 137.278965,21.0330162 137.011576,18.8131637 Z",
    id: "petal-right",
    fill: "#5BD7C5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(72.145390, 46.248626)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1469558,21.5866499 C31.7007751,24.1467452 31.7007751,28.2974667 29.1469558,30.8575517 C26.5931568,33.4176573 22.4526223,33.4176573 19.8988132,30.8575517 C17.3449937,28.2974667 17.3449937,24.1467452 19.8988132,21.5866499 C22.4526223,19.0265548 26.5931568,19.0265548 29.1469558,21.5866499",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3498199,35.4177358 C18.8613249,38.9378545 18.8613249,44.6451044 15.3498199,48.165223 C11.8383359,51.6853628 6.14510479,51.6853628 2.63362087,48.165223 C-0.877873623,44.6451044 -0.877873623,38.9378545 2.63362087,35.4177358 C6.14510479,31.8975959 11.8383359,31.8975959 15.3498199,35.4177358",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0229599,1.20005353 C57.6190984,2.80010173 57.6190984,5.39430309 56.0229599,6.99436289 C54.4268331,8.59442267 51.8389997,8.59442267 50.2428727,6.99436289 C48.6467343,5.39430309 48.6467343,2.80010173 50.2428727,1.20005353 C51.8389997,-0.400017843 54.4268331,-0.400017843 56.0229599,1.20005353",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3395271,11.2733493 C46.2548922,13.1934094 46.2548922,16.3064484 44.3395271,18.2265185 C42.4241719,20.1465986 39.3187763,20.1465986 37.403421,18.2265185 C35.4880559,16.3064484 35.4880559,13.1934094 37.403421,11.2733493 C39.3187763,9.35326926 42.4241719,9.35326926 44.3395271,11.2733493",
    id: "Fill-10"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcsmTulip);
export default __webpack_public_path__ + "static/media/ccsm-tulip.37d75b6e92b9f5adbfe85f3cc8dc1bf8.svg";
export { ForwardRef as ReactComponent };